import { BaseResource } from './base';
import {
  CommissionConfigDto,
  CreateCommissionConfigDto,
  UpdateCommissionConfigDto,
  CommissionHistoryDto,
  CommissionHistoryFiltersDto,
} from '../models/commissions';
import { RequestOptions, PaginatedResponseDto } from '../types';

export class CommissionConfigResource extends BaseResource {
  private basePath = 'commissions/config';

  async createConfig(
    data: CreateCommissionConfigDto,
    options?: RequestOptions,
  ): Promise<CommissionConfigDto> {
    return this.client.post<CommissionConfigDto>(this.basePath, data, options);
  }

  async getActiveConfig(options?: RequestOptions): Promise<CommissionConfigDto> {
    return this.client.get<CommissionConfigDto>(`${this.basePath}/active`, undefined, options);
  }

  async getConfig(id: string, options?: RequestOptions): Promise<CommissionConfigDto> {
    return this.client.get<CommissionConfigDto>(`${this.basePath}/${id}`, undefined, options);
  }

  async listConfigs(
    params?: { page: number; limit: number },
    options?: RequestOptions,
  ): Promise<PaginatedResponseDto<CommissionConfigDto>> {
    return this.paginate<CommissionConfigDto>(this.basePath, params, options);
  }

  async updateConfig(
    id: string,
    data: UpdateCommissionConfigDto,
    options?: RequestOptions,
  ): Promise<CommissionConfigDto> {
    return this.client.put<CommissionConfigDto>(`${this.basePath}/${id}`, data, options);
  }

  async deactivateConfig(id: string, options?: RequestOptions): Promise<CommissionConfigDto> {
    return this.client.put<CommissionConfigDto>(`${this.basePath}/${id}/deactivate`, {}, options);
  }

  async getConfigHistory(
    id: string,
    params?: CommissionHistoryFiltersDto,
    options?: RequestOptions,
  ): Promise<PaginatedResponseDto<CommissionHistoryDto>> {
    return this.paginate<CommissionHistoryDto>(`${this.basePath}/${id}/history`, params, options);
  }

  async validateConfig(
    data: CreateCommissionConfigDto,
    options?: RequestOptions,
  ): Promise<{ valid: boolean; errors?: string[] }> {
    return this.client.post<{ valid: boolean; errors?: string[] }>(
      `${this.basePath}/validate`,
      data,
      options,
    );
  }
}
